import { render, staticRenderFns } from "./user_notice.vue?vue&type=template&id=5e5fbcc9&"
import script from "./user_notice.vue?vue&type=script&lang=js&"
export * from "./user_notice.vue?vue&type=script&lang=js&"
import style0 from "./user_notice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_chaxin_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports